pageId = 'page-join-approval-detail'
page = "##{ pageId }"

$ ->
  $(document)
  .on 'click', "#{ page } .select-all", selectAll
  .on 'click', "#{ page } .toggle-archived-projects", toggleArchivedProjects

selectAll = (e) ->
  e.preventDefault()
  btn = $(@)

  if btn.is('.select-all-projects')
    if btn.is('.inverse')
      $('tr-project-checkboxes').get(0).unselectAll()
    else
      $('tr-project-checkboxes').get(0).selectAll()
  else
    btn.closest('.form-item')
      .find('input[type=checkbox]:enabled')
      .prop 'checked', !btn.is('.inverse')

toggleArchivedProjects = (e) ->
  archivedProjects = $('.archived-projects')
  txt = if archivedProjects.is(':visible') then '显示已归档项目' else '隐藏已归档项目'
  $(@).text(txt)
  archivedProjects.toggle()
  if !archivedProjects.is(':visible')
    archivedProjects.find('input[type=checkbox]').prop('checked', false)
